import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

import { media } from '@myrealtrip/modash';
import { Text } from '@myrealtrip/web-ui';

import { AGE_NOTIFICATION_MESSAGES } from '~constants/pointToPointTicket';

const TravelerNotificationList = () => {
  const theme = useTheme();

  return (
    <AgeNotifications>
      {AGE_NOTIFICATION_MESSAGES.map((message, index) => (
        <AgeNotification key={index}>
          <Text typography="paragraphNormal14" color={theme.colors.gray.s600}>
            {message}
          </Text>
        </AgeNotification>
      ))}
    </AgeNotifications>
  );
};

const AgeNotifications = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
  margin: 20px 16px 16px;
  background: ${({ theme: { palettes } }) => palettes.gray[50]};
  border-radius: 12px;

  ${media.minMobile} {
    margin: 16px;
  }
`;

const AgeNotification = styled.li`
  position: relative;
  display: flex;
  justify-content: flex-start;
  gap: 6px;
  padding-left: 8px;

  &::before {
    content: '';
    position: absolute;
    top: calc(19px / 2);
    left: 0;
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background-color: ${({ theme: { palettes } }) => palettes.gray[600]};
    margin-right: 6px;
  }
`;

export default TravelerNotificationList;
